export default "__VITE_ASSET__IZnMUXPL__"